import { ParentWorkItemContext, WorkItemComment } from "../../common/clients/ogg";
import { transcriptionKey } from "../../common/components/agents/scribe/ScribePresentation";
import { CachingService } from "../../common/services/caching.service";
import { IWorkItemManager, Rating } from "../../common/types";

export default class WorkItemServiceForWebApp implements IWorkItemManager {
    cache = {};

    constructor() {
    }
    
    
    
    private async getField(fieldName: string): Promise<string> {
        console.log("Getting field", fieldName);
        return this.cache[fieldName];
    }

    async getId(): Promise<string> {
        return "Intriq";
    }

    async getTitleField(): Promise<string> {
        return await this.getField("System.Title");
    }
    async getDescriptionField(): Promise<string> {
        return await this.getField("System.Description");
    }
    async getAcceptanceCriteriaField(): Promise<string> {
        return await this.getField("Microsoft.VSTS.Common.AcceptanceCriteria");
    }
    async getParentWorkItem(): Promise<ParentWorkItemContext> {
        return null;
    }
    async getComments(): Promise<WorkItemComment[]> {
        return [];
    }
    async getMeetingTranscription(): Promise<string> {
        return CachingService.getValue(transcriptionKey, this);
    }
    async getUrl(workItemId?: string): Promise<string> {
        return `/intriq/${workItemId}`;
    }

    private async setField(fieldName: string, value: string): Promise<void> {
        console.log(`Setting field ${fieldName} with value ${value}`);
        this.cache[fieldName] = value;
    }

    async setTitleField(value: string): Promise<void> {
        await this.setField("System.Title", value);
    }
    async setDescriptionField(value: string): Promise<void> {
        await this.setField("System.Description", value);
    }
    async setAcceptanceCriteriaField(value: string): Promise<void> {
        await this.setField("Microsoft.VSTS.Common.AcceptanceCriteria", value);
    }

    saveRating(rating: Rating): Promise<void> {
        throw new Error("Saving rating not supported in webapp. Install the Azure DevOps or Jira extension to access all features.");
    }
    openWorkItemCreateForm(type: string, initialValues?: { [fieldName: string]: Object; }): Promise<string | null> {
        throw new Error("Creating a new work item is not supported in the webapp. Install the Azure DevOps or Jira extension to access all features.");
    }
    async openWorkItem(workItemId: string): Promise<void> {
        throw new Error("Opening a work item is not supported in the webapp. Install the Azure DevOps or Jira extension to access all features.");
    }
}